<template>
	<div v-if="visible" class="message-menu-options" @click.stop :class="{'is-rtl':layoutStore.isRTL}">
		<div class="menu-wrapper" @click="copyText">
			<p class="txt">{{ $t('copy-text') }}</p>
		</div>
	</div>
</template>

<script setup>
import { onMounted, onBeforeUnmount, computed } from 'vue';
import { useLayoutStore } from '@/v2/store/shared/layout-store';

const emit = defineEmits(['set-active-menu']);
const layoutStore = useLayoutStore();

const props = defineProps({
	message: {
		type: Object,
		required: true,
	},
	activeMenu: String,
	tenant: String,
});

const visible = computed(() => {
	return props.activeMenu === props.message?.id;
});

onMounted(() => {
	document.addEventListener('click', hideMenu);
});

onBeforeUnmount(() => {
	document.removeEventListener('click', hideMenu);
});

// const showMenu = () => {
// 	emit('set-active-menu', props.message?.id);
// };

const hideMenu = () => {
	emit('set-active-menu', null);
};

const handleAction = () => {
	hideMenu();
};

const copyText = async () => {
	console.log('text', props?.message?.content);
	try {
		// Use the Clipboard API to copy the text
		await navigator.clipboard.writeText(props?.message?.content);
		hideMenu();
	} catch (err) {
		// Handle errors (e.g., if clipboard access is denied)
		console.error('Failed to copy text: ', err);
	}
};

defineExpose({
});
</script>

<style scoped lang="scss">
.message-menu-options {
	position: absolute;
	background-color: white;
	border: 1px solid #eaecf0;
	box-shadow: 0px 4px 12px 0px #0000003d;
	border-radius: 8px;
	z-index: 1000;
    width: max-content;
    right: 0;
    &.is-rtl{
        left: 0;
        right: auto;
    }
	.menu-wrapper {
		display: flex;
		gap: 10px;
		padding: 16px;
		align-items: center;
        cursor: pointer;
		.txt {
			font-size: 14px;
			font-weight: 500;
			color: #0c111d;
			margin-bottom: 0;
		}
	}
}
</style>
